<template>
  <div>

    <Navigation/>

    <div class="container is-fluid" style="margin-top:18px;">

      <h2 class="title is-2" style="color:#fff;">Manage Subscription</h2>

      <div class="card">
        <div class="card-content" v-if="currentUser && stripeCustomerInitialized">

          <h4 class="title is-4">My Credit Cards</h4>

          <div class="columns">

            <div class="column is-one-quarter" v-for="source in sources">
              <div class="card">
                <div class="card-content">
                  <p class="title">
                    <i v-if="source.card.brand === 'Visa'" class="fa fa-2x fa-cc-visa credit-card-icon"></i>
                    <i v-if="source.card.brand === 'Mastercard'" class="fa fa-2x fa-cc-mastercard credit-card-icon"></i>
                    <i v-if="source.card.brand === 'Discover'" class="fa fa-2x fa-cc-discover credit-card-icon"></i>
                    <i v-if="source.card.brand === 'American Express'" class="fa fa-2x fa-cc-amex credit-card-icon"></i>
                    <span class="is-pulled-right title is-4">****{{source.card.last4}}</span>
                  </p>
                </div>
                <footer class="card-footer">
                  <p class="card-footer-item">
                    <span>
                      {{source.card.exp_month}} / {{source.card.exp_year}}
                    </span>
                  </p>
                  <p class="card-footer-item">
                    <span>
                      <a @click="removePaymentSource(source)">
                        <i class="fa fa-close" style="color:red"></i>
                      </a>
                    </span>
                  </p>
                </footer>
              </div>
            </div>

            <div class="column is-two-quarters">
              <div class="card" style="background:#fbfbfb;">
                <div class="card-content">
                  <p class="subtitle">
                    <i class="fa fa-plus-circle"></i>
                    Add a new Card
                  </p>
                  <card class='stripe-card'
                    :class='{ complete }'
                    :stripe='stripeKey'
                    @change='complete = $event.complete'
                  />

                </div>
                <footer class="card-footer">
                  <a
                    v-if="complete"
                    href="#"
                    class="card-footer-item"
                    @click='submitNewCreditCard'
                    :class="{'is-success': complete, 'is-static': !complete}">
                    Add Card
                  </a>
                </footer>
              </div>
            </div>

          </div>

          <h4 class="title is-4">Billing History</h4>
          <hr>
          <p>Nothing here</p>

          <!--
          <ul>
            <li v-for="(charge, id) in charges">
              {{ charge.amount }}
              <span v-if="charge.error">
                {{ charge.error }}
              </span>
              <span v-else-if="charge.outcome">
                {{ charge.outcome.seller_message }}
                {{ charge.source.brand }} &hellip;{{ charge.source.last4 }}
                (exp. {{ charge.source.exp_month }}/{{ charge.source.exp_year }})
              </span>
              <span v-else>&hellip;</span>
            </li>
          </ul>


              <h4>New Charge</h4>
              <div>
                <label>
                  Card
                  <select v-model="newCharge.source">
                    <option :value="null">Default payment method</option>
                    <option v-for="(source, id) in sources" v-bind:value="source.id" v-if="source.id">
                      {{ source.brand }} &hellip;{{ source.last4 }}
                      (exp. {{ source.exp_month }}/{{ source.exp_year }})
                    </option>
                  </select>
                </label>
              </div>
              <div>
                <label>
                  Amount <input v-model="newCharge.amount">
                </label>
              </div>
              <div>
              <button v-on:click="submitNewCharge">Charge</button>
                {{ newCharge.error }}
              </div>

          </div>
          -->

            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import firebase from 'firebase';
import Navigation from './Navigation';
import { Card, createToken } from 'vue-stripe-elements-plus';

/*
// Example credit card
const = newCreditCard: {
  number: '4242424242424242',
  cvc: '111',
  exp_month: 1,
  exp_year: 2020,
  address_zip: '00000'
};
*/

export default {
  name: 'Subscription',
  components: {
    Navigation,
    Card,
  },
  data() {
    return {
      stripeKey: 'pk_test_jj4hvkB0ioUOJx2Ah3v46AWh',
      complete: false,
      currentUser: null,
      sources: {},
      stripeCustomerInitialized: false,
      charges: {},
      newCharge: {
        source: null,
        amount: 2000
      },
      stripeCustomerPath: null,
    };
  },
  mounted() {
    Stripe(this.stripeKey);
    this.currentUser = firebase.auth().currentUser;
    this.getCustomer();
  },
  methods: {
    getCustomer() {
      this.stripeCustomerPath = `/stripe_customers/${this.currentUser.uid}/`;

      firebase.database().ref(`${this.stripeCustomerPath}/customer_id`).once('value', snapshot => {
        this.stripeCustomerInitialized = (snapshot.val() !== null);
      }, () => {
        this.stripeCustomerInitialized = false;
      });
      firebase.database().ref(`${this.stripeCustomerPath}/sources`).once('value', snapshot => {
        this.sources = snapshot.val();
      }, () => {
        this.sources = {};
      });
      firebase.database().ref(`${this.stripeCustomerPath}/charges`).once('value', snapshot => {
        this.charges = snapshot.val();
      }, () => {
        this.charges = {};
      });
    },
    removePaymentSource(source) {

    },
    submitNewCreditCard() {
      createToken().then((data) => {
        var response = data.token;
        console.log(data.token);

        // New Card
        let newSource = {
          token: response.id,
          card: response.card,
        };

        firebase.database().ref(`{this.stripeCustomerPath}/sources`).push(newSource).then(() => {
          // API call here to trigger new stripe source creation

          this.$toast.open({
            message: 'Successfully added card.',
            type: 'is-success'
          });
        });
      }).catch((error) => {
        console.log(error);
        this.$toast.open({
          message: 'Error adding card.',
          type: 'is-danger'
        });
      });
    },
    submitNewCharge() {
      firebase.database().ref(`${this.stripeCustomerPath}/charges`).push({
        source: this.newCharge.source,
        amount: parseInt(this.newCharge.amount)
      }).then(() => {

        this.$toast.open({
          message: 'Successfully added new subscription.',
          type: 'is-success'
        });

      }).catch((error) => {
        console.log(error);
        this.$toast.open({
          message: 'Error adding new subscription.',
          type: 'is-danger'
        });
      });
    },
  }
};
</script>

<style scoped>
.credit-card-icon {
  color: #bb2980;
}
.stripe-card {
  width: 100%;
  border: 1px solid #e4e4e4;
  padding: 8px 10px;
  border-radius: 5px;
  margin: 21px 0px;
}
.stripe-card.complete {
  border-color: green;
}
</style>



// WEBPACK FOOTER //
// src/components/Subscription.vue